export default __webpack_public_path__ + "static/media/defoult_avatar.aa5567f6.png";